
import React, { useEffect } from "react";
import { useGlobalContext } from "../../context";
import { inputType } from "../../interfaces";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import StarRateIcon from "@mui/icons-material/StarRate";

type propsType = {
    client: any
}

function Emails({ client }: propsType) {

    const {
        emailData,
        setEmailData
    } = useGlobalContext()

    const updateEmailsData = (emails: string[]) => {
        const userEmails: inputType[] = [];
        emails.forEach((email: string, index: number) => {
            let obj: inputType = {
                id: index + 1,
                text: email
            }
            userEmails.push(obj);
        })
        setEmailData(userEmails);
    }

    useEffect(() => {
        if (client) {
            updateEmailsData(client.emails);
        }
    }, [client])

    const addEmailAddress = () => {
        if (emailData.length < 5) {
            const lastId: number = emailData[emailData.length - 1].id + 1;
            setEmailData((emailData: inputType[]) => {
                return [
                    ...emailData,
                    {
                        id: lastId,
                        text: ""
                    }
                ]
            })
        }
    }

    const deleteEmailAddress = (id: number) => {
        setEmailData((emailData: inputType[]) => emailData.filter((e: inputType) => e.id !== id));
    }

    const handleEmailChange = (value: string, id: number) => {
        setEmailData((emailData: inputType[]) => emailData.map((item: inputType) => item.id === id ? { ...item, text: value } : { ...item }));
    }

    return(
        <div className = "Emails">
            <div className = "form-emailAddress-box">
                <label className = "required">Email <span>Max 5</span> <StarRateIcon style = {{ color: "red", fontSize: "10px" }}/></label>
            </div>
            <div>
                {
                    emailData.map((ea: inputType) => (
                        <div className = "form-emailAddress-box " key = {ea.id}>
                            <input
                                className = "emailAddress-box-email-input"
                                type = "email"
                                value = { ea.text }
                                onChange = { (e) => handleEmailChange(e.target.value, ea.id) }
                            />
                            {
                                ea.id === 1 ?
                                    <div className = "emailAddress-box-add">
                                        <AddIcon
                                            className = "box-addEmail-icon"
                                            onClick = { addEmailAddress }
                                        />
                                    </div>
                                    :
                                    <div className = "phoneNumber-box-delete">
                                        <DeleteIcon
                                            className = "box-deletePhone-icon"
                                            onClick = { () => deleteEmailAddress(ea.id) }
                                        />
                                    </div>
                            }
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default Emails
